import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, Staff, StaffWrite } from 'types';
import { client } from 'utils/api-client';

const updateStaff = (staff: StaffWrite): Promise<AxiosResponse<Staff>> => {
  return client.put(`staff/${staff.staffId}/`, staff);
};

export default function useUpdateStaff(): UseMutationResult<
  AxiosResponse<Staff>,
  AxiosError<ErrorMessage>,
  StaffWrite
> {
  const queryClient = useQueryClient();

  return useMutation(updateStaff, {
    onSuccess: () => {
      queryClient.invalidateQueries(['staff']);
      queryClient.invalidateQueries(['classes']);
      queryClient.invalidateQueries(['appointments']);
      queryClient.invalidateQueries('events');
      queryClient.invalidateQueries('staff-autocomplete');
    },
  });
}
